<template>
    <div class="signature-form">
        <form v-on:submit.prevent="onSubmit" class="pure-form pure-form-stacked">
            <div class="col-left">
                <div class="form-row">
                    <label for="siteAO">
                        <input type="checkbox" name="siteAO" value="siteAO" id="siteAO" v-model="formFields.checkedSites">
                            AO
                    </label>
                </div>
                <div class="form-row">
                    <label for="siteContinued">
                        <input type="checkbox" name="siteContinued" value="siteContinued" id="siteContinued" v-model="formFields.checkedSites">
                            Continu<strong>ed</strong>
                    </label>
                </div>
                <div class="form-row">
                    <label for="siteLacalle">
                        <input type="checkbox" name="siteLacalle" value="siteLacalle" id="siteLacalle" v-model="formFields.checkedSites">
                            LaCalle Group
                    </label>
                </div>
                <div class="form-row">
                    <label for="siteOT">
                        <input type="checkbox" name="siteOT" value="siteOT" id="siteOT" v-model="formFields.checkedSites">
                            OT
                    </label>
                </div>
                <div class="form-row">
                    <label for="sitePT">
                        <input type="checkbox" name="sitePT" value="sitePT" id="sitePT" v-model="formFields.checkedSites">
                            PT
                    </label>
                </div>
                <div class="form-row">
                    <label for="siteAll">
                        <input type="checkbox" name="siteAll" value="siteAll" id="siteAll" v-model="formFields.checkedSites">
                            Sales (Continu<strong>ed</strong> All Verticals)
                    </label>
                </div>
                <div class="form-row">
                    <label for="siteSimucase">
                        <input type="checkbox" name="siteSimucase" value="siteSimucase" id="siteSimucase" v-model="formFields.checkedSites">
                            Simucase
                    </label>
                </div>
                <div class="form-row">
                    <label for="siteSP">
                        <input type="checkbox" name="siteSP" value="siteSP" id="siteSP" v-model="formFields.checkedSites">
                            SP
                    </label>
                </div>
                
                <div class="form-row">
                    <label for="macClient">
                        <input type="checkbox" name="macClient" value="true" id="macClient" v-model="formFields.macClient">
                        Built-in Mac Mail Client			
                    </label>
                </div>

                <div class="tips">
                    <ol>
                        <li>Select vertical(s) above</li>
                        <li>Fill in your details to the right</li>
                        <li>Click the "Copy Signature" button to copy the signature to your clipboard.</li>
                        <li>Paste the signature into Gmail under the Settings->General tab.</li>
                        <li>You can also copy a signature just by highlighting and copying it.</li>
                    </ol>
                </div>
            </div>

            <div class="col-right">
                <div class="form-row">
                    <label for="firstName">First Name</label>
                    <input type="text" name="firstName" id="firstName" v-model="formFields.firstName">
                </div>
                <div class="form-row">
                    <label for="lastName">Last Name</label>
                    <input type="text" name="lastName" id="lastName" v-model="formFields.lastName">
                </div>
        
                <div class="form-row">
                    <label for="title">Title</label>
                    <input type="text" name="title" id="title" v-model="formFields.title">
                </div>

                <div class="form-row">
                    <label for="pronouns">Pronouns (Optional)</label>
                    <input type="text" name="pronouns" id="pronouns" v-model="formFields.pronouns">
                </div>
        
                <div class="form-row">
                    <label for="email">Email User</label>
                    <input type="text" name="email" id="email" placeholder="example: dwight.schrute"  v-model="formFields.emailUser">
                </div>
        
                <div class="form-row">
                    <label for="extension">Phone Ext.</label>
                    <input type="text" name="extension" id="extension" placeholder="example: 250" v-model="formFields.extension" >
                </div>
        
                <div class="form-row">
                    <label for="directLine">Direct Line</label>
                    <input type="text" name="directLine" id="directLine" v-model="formFields.directLine" :disabled="formFields.extension.length > 0">
                    <span class="pure-form-message">If not using 800/888 number with extension</span>
                </div>
        
                <div class="form-row">
                    <label for="fax">Fax (Optional)</label>
                    <input type="text" name="fax" id="fax" v-model="formFields.fax">
                </div>
        
                <div class="form-row">
                    <label for="mobile">Mobile Phone (Optional)</label>
                    <input type="text" name="mobile" id="mobile" v-model="formFields.mobile">
                </div>
            </div>
        </form>

        <div class="preview">
            <Lcms v-if="formFields.checkedSites.indexOf('siteAO') !== -1" site="siteAO" :formFields=formFields class="signature-container" />
            <Lcms v-if="formFields.checkedSites.indexOf('siteContinued') !== -1" site="siteContinued" :formFields=formFields class="signature-container" />
            <LacalleGroup v-if="formFields.checkedSites.indexOf('siteLacalle') !== -1" site="siteLacalle" :formFields=formFields class="signature-container" />
            <Lcms v-if="formFields.checkedSites.indexOf('siteOT') !== -1" site="siteOT" :formFields=formFields class="signature-container" />
            <Lcms v-if="formFields.checkedSites.indexOf('sitePT') !== -1" site="sitePT" :formFields=formFields class="signature-container" />
            <Sales v-if="formFields.checkedSites.indexOf('siteAll') !== -1" site="siteAll" :formFields=formFields class="signature-container" />
            <Simucase v-if="formFields.checkedSites.indexOf('siteSimucase') !== -1" site="siteSimucase" :formFields=formFields class="signature-container" />
            <Lcms v-if="formFields.checkedSites.indexOf('siteSP') !== -1" site="siteSP" :formFields=formFields class="signature-container" />
        </div>

    </div>
</template>

<script>
import Sales from './signatures/Sales';
import Simucase from './signatures/Simucase';
import Lcms from './signatures/Lcms';
import LacalleGroup from './signatures/LacalleGroup';

export default {
    name: 'SignatureForm',
    components: {
        Sales,
        Simucase,
        Lcms,
        LacalleGroup
    },
    data: function() {
        return {
            formFields: {
                firstName: '',
                lastName: '',
                title: '',
                pronouns: '',
                emailUser: '',
                extension: '',
                directLine: '',
                fax: '',
                mobile: '',
                checkedSites: [],
                macClient: false
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @import url('https://fonts.googleapis.com/css?family=Open+Sans:400,400i,700');
    @import url('https://unpkg.com/purecss@1.0.0/build/pure-min.css');
    form {
        box-sizing: border-box;
        display: inline-block;
        font-family: 'Open Sans', sans-serif;
        margin-top: 20px;
        width: 610px;
    }

    .col-left {
        display: inline-block;
        padding: 10px;
        width: 250px;
    }

    .col-right {
        display: inline-block;
        width: 330px;
        vertical-align: top;
    }

    .col-right input {
        width: 300px;
    }

    .col-right .form-row {
        margin-bottom: 10px;
    }

    .preview {
        display: inline-block;
        height: 95vh;
        overflow-y: auto;
        position: fixed;
        right: 0;
        width: calc(100vw - 630px);
        vertical-align: top;
    }

    .signature-container {
        margin: 20px 0 40px;
    }

    .tips {
        color: #999;
        font-size: .8rem;
        width: 220px;
    }

    .tips > ol {
        line-height: 1.2rem;
        margin-top: 20px;
        padding-left: 20px;
    }

    @media (max-width: 1023px) {
        .preview {
            display: block;
            height: auto;
            margin: 20px;
            overflow-y: inherit;
            position: relative;
            right: 0;
            width: 90%;
        }
    }

    @media (max-width: 640px) {
        .col-right {
            display: block;
            margin: 20px;
            width: 90%;
        }

        .tips {
            display: none;
        }
    }
</style>
